import { combineReducers } from 'redux'
import methods from '../methods'
import matchReducer from './match'
import configReducer from './config'
import langReducer from './lang'


const appReducer = combineReducers({
    configReducer,
    matchReducer,
    langReducer
})
  
const rootReducer = (state, action) => {
    if (action.type === methods.USER_LOGOUT) {
        state = undefined
    }
    if(action.type === methods.LOGOUT) {
        state = undefined
    }

    return appReducer(state, action)
}

export default rootReducer